import { v4 as uuidv4 } from 'uuid'
//----------------
// create temp id
//----------------
export default function createTempId() {
  /*
   Example: TMP-1733404800000-k5j7h9m2p
  */
  return `TMP-${uuidv4()}`
}
